import { render, staticRenderFns } from "./CustomerDetailProducts.vue?vue&type=template&id=2eb608a1&scoped=true&"
import script from "./CustomerDetailProducts.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailProducts.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailProducts.vue?vue&type=style&index=0&id=2eb608a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb608a1",
  null
  
)

export default component.exports